import React from "react";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";
export default function BadgePills({ data }) {
  return (
    <article className="container md:mt-5 lg:mt-5">
      <ul className="badge-grid-wrap fx fx--cv fx--sb">
        {data.map((data, index) => {
          return (
            <li className="badge-grid-item fx fx--cv fx--ch" key={index}>
              <img
                src={data.src}
                alt={data.alt}
                width={data.dimensions[0]}
                height={data.dimensions[1]}
                loading="lazy"
              />
            </li>
          );
        })}
        <style jsx>
          {`
            .badge-grid-item {
              width: 200px;
              height: 200px;
            }
            @media (max-width: ${viewport.tablet.sm}) {
              .badge-grid-wrap {
                gap: 20px;
                max-width: 330px;
                flex-wrap: wrap;
                justify-content: center;
                margin: auto;
              }
              .badge-grid-item {
                width: 155px;
                height: 160px;
                gap: 20px;
                padding: 16.8px 22px 17.2px;
                border-radius: 4.8px;
                background-color: ${colors.primitive.white.default};
              }
              .badge-grid-wrap .badge-grid-item:last-child {
                display: none;
              }
              .badge-grid-item img {
                width: 100%;
                height: auto;
              }
            }
          `}
        </style>
      </ul>
    </article>
  );
}
